/* eslint-disable */ 
import qs from 'qs';
/* eslint-disable */ 
import { payloadToQuery } from '@/utils/index';
import request from '../index.js';

// 根据菜单id获取详情
export const getMenuDetailById = (data) => request.get(`/api-eye/menu/getMenuDetailById?${qs.stringify(data)}`);

// 根据登录角色获取菜单结构
export const getMenuTreeByRoleId = (data) => request.get(`/api-eye/menu/getMenuTreeByRoleId?${qs.stringify(data)}`);

// 获取菜单结构
export const getMenuTree = (data) => request.get('/api-eye/menu/getMenuTree');

// 添加/更新菜单
export const saveOrUpdateMenu = (data) => request.post('/api-eye/menu/saveOrUpdateMenu', data);


// 删除菜单
export const deleteMenu = (data) => {
  // const url = payloadToQuery(data, '/api-eye/menu/deleteMenu');
  return request.delete(...payloadToQuery(data, '/api-eye/menu/deleteMenu', true));
};

// 管理员列表 
export const getAllRole = (data) => request.get('/api-eye/role/getAllRole');

// 添加或更新角色
export const saveOrUpdateRole = (data) => request.post('/api-eye/role/saveOrUpdateRole', data);

// 删除角色
export const deleteRoleById = (data) => {
  // const url = payloadToQuery(data, '/api-eye/role/deleteRoleById');
  return request.delete(...payloadToQuery(data, '/api-eye/role/deleteRoleById'));
};

// 根据角色id获取已选权限id集合
export const getIdentifyByRoleId = (data) => request.get(`/api-eye/permissionsRole/getIdentifyByRoleId?${qs.stringify(data)}`);

// 根据角色id获取权限标识集合
export const getPermissionsRoleByRoleId = (data) => request.get(`/api-eye/permissionsRole/getPermissionsRoleByRoleId?${qs.stringify(data)}`);

// 给角色添加权限
export const insertPermissionRole = (data) => {
  // const url = payloadToQuery(data, '/api-eye/permissionsRole/insertPermissionRole');
  const list = payloadToQuery(data, '/api-eye/permissionsRole/insertPermissionRole?', true);
  return request.post(list[0], list[1].data );
};

// 添加或更新权限
export const saveOrUpdatePermission = (data) => request.post('/api-eye/permissions/saveOrUpdatePermission', data);

// 获取所有权限的树结构
export const getPermissionTree = (data) => request.get(`/api-eye/permissions/getPermissionTree?${qs.stringify(data)}`);

// 根据权限id获取权限详情
export const getPermissionById = (data) => request.get(`/api-eye/permissions/getPermissionById?${qs.stringify(data)}`);

// 根据权限id删除权限
export const deletePermission = (data) => {
  // const url = payloadToQuery(data, '/api-eye/permissions/deletePermission');
  return request.delete(...payloadToQuery(data, '/api-eye/permissions/deletePermission'));
};
